import { createAction } from '../../../store.model';
import { ActionType } from '../transcript-import-dialog.action';

export interface SelectDateRange {
    from: Date;
    to: Date;
}

export const selectDateRange = createAction<ActionType, SelectDateRange>(
    ActionType.TC__TI__SELECT_DATE_RANGE,
);
